import * as React from "react";
import { Modal, Button } from "react-bootstrap";

interface IProps {
    show: boolean,
    product: string,
    center?: string,
    onDelete: () => void,
    onCancel: () => void
}

class DeleteProduct extends React.Component<IProps, {}> {
    handleDelete = () => {
        this.props.onDelete();
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    render = () => {
        return (
            <>
                <Modal show={this.props.show} onHide={this.handleCancel}>
                    <Modal.Header closeButton><h4 style={{ margin: 0 }}>Delete Targeted Product {this.props.center != null ? 'from ' + this.props.center : ''}</h4></Modal.Header>
                    <Modal.Body>
                        <div>Are you sure you want to delete the following targeted product:</div>
                        <div style={{ marginTop: 10, marginLeft: 20 }}>
                            {this.props.product}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle='danger' onClick={this.handleDelete}>Delete</Button>
                        <Button onClick={this.handleCancel}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default DeleteProduct;